<template>
  <div class="header">
    <div class="icons" @click="handlerGoback">
      <img src="http://cdn.gugusj.com/xdk/icon01.png" alt="">
    </div>
    <div class="center" v-show="showCenter">
      <div class="list">
        <div class="lis" :class="active == '/home' ? 'active' : ''"
          @click="handlernav('/home')">产品</div>
        <div class="lis" :class="active == '/price' ? 'active' : ''" @click="handlernav('/price')">定价
        </div>
        <!-- <div class="lis" :class="active == 3 ? 'active' : ''" @click="handlernav(3)">工作台</div> -->
      </div>
    </div>
    <div class="rights">
      <div class="login" v-show="!$store.state.tokens" @click="handlerShows">登录 / 注册</div>

      <div class="userimgs" v-show="$store.state.tokens">
        <div class="imgsdv">
          <img class="imgs" v-if="avatarUrl" :src="avatarUrl" alt="">
          <span v-else>XDK</span>
        </div>
        <div class="logindv">
          <div class="tops">
            <div class="iconsone">
              <img class="imgs" v-if="avatarUrl" :src="avatarUrl" alt="">
              <span v-else>XDK</span>
            </div>
            <div class="texts">{{nickname}}</div>
          </div>
          <div class="ctdvs">
            
            <div class="title1">{{ setviplever.vipLevel == 3?'续费':'升级' }}{{ setviplever.cardDefinition?setviplever.cardDefinition.cardName:'' }}</div>
            <div class="title2">文案生成上限{{setviplever.cardDefinition?setviplever.cardDefinition.count:0}}次(有效期{{setviplever.cardDefinition?setviplever.cardDefinition.durationDays:0}}天)</div>
            <div class="btns" @click="handlerTopathone"> {{setviplever.vipLevel == 3?'立即续费':'立即升级'}}</div>
          </div>
          <div class="list">
            <div class="lis"  @click="handlerTopath(1)">
              <span>账号信息</span>
              <span class="el-icon-arrow-right"></span>
            </div>
            <div class="lis" @click="handlerTopath(2)">
              <span>订单管理</span>
              <span class="el-icon-arrow-right"></span>
            </div>
            <div class="lis" @click="handlerTopathtwo(3)">
              <span>工作台</span>
              <span class="el-icon-arrow-right"></span>
            </div>
          </div>
          <div class="line">
  
          </div>
          <div class="loginout" @click="handlerLogout">
            退出登录
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>
<script>
// import {getSmsCode} from '@/api/login'
import {getUserInfo} from '@/api/home'
export default {
  name: 'HeaderComponent',

  data() {
    return {
      active: '/home',
      actives: 1,
      showCenter: true,
      input3: "",
      cozeBg: false,
      ruleForm: {
        phone: "",
        code: ""
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      }
    }
  },
  computed:{
    avatarUrl(){
      let user = ""
      let userProfile = this.$store.state.user&& this.$store.state.user.userProfile ? this.$store.state.user.userProfile:{}
      if(!userProfile.avatarUrl){
        user = JSON.parse(localStorage.getItem('user')) || {}
      }else{
        user = this.$store.state.user || {}
      }
      return  user.userProfile?user.userProfile.avatarUrl:''
    },
    nickname(){
      let user = ""
      let userProfile = this.$store.state.user&& this.$store.state.user.userProfile ? this.$store.state.user.userProfile:{}
      if(!userProfile.avatarUrl){
        user = JSON.parse(localStorage.getItem('user')) || {}
      }else{
        user = this.$store.state.user || {}
      }
      return  user.userProfile?user.userProfile.nickname: ''
    },
    setviplever(){
      let lervers = {}
      let setviplever = this.$store.state.setviplever
      console.log(setviplever,'setviplever')
      if(!setviplever.vipLevel){
        lervers = JSON.parse(localStorage.getItem('setviplever')) || {}
      }else{
        lervers = this.$store.state.setviplever || {}
      }
      return  lervers
    }
  },
  watch: {
    $route(to) {
      // console.log(to,from)
      this.active = to.fullPath
      if (to.fullPath == '/AccountSettings' || to.fullPath == '/cozeIndex') {
        this.showCenter = false
      } else {
        this.showCenter = true
      }
    },
  },
  created() {
    console.log(this.$store.state,'this.$store.state.setviplever')
    let data = JSON.parse(localStorage.getItem('datas'))
    let token = data && data.qrAuth.accessToken ? data.qrAuth.accessToken : ""
    console.log(token,'ppps')
    this.$store.commit('SETTOKENS', token)
    this.active = this.$route.fullPath
    if (this.active == '/AccountSettings' || to.fullPath == '/cozeIndex') {
      this.showCenter = false
    } else {
      this.showCenter = true
    }
  },
  // mounted() {
  //   kg.captcha({
  //           // 绑定弹窗按钮
  //           button: "#captchaButton",
  //           float: "top",
  //           // 验证成功事务处理
  //           success: function (e) {
  //               console.log(e,'ppp');
  //               // 将验证成功后的 token 通过隐藏域传递到后端
  //               kg.$("#kgCaptchaToken").value = e["token"];
  //               kg.html(kg.$("#captchaButton"), "验证成功，请提交数据");
  //               kg.$("#captchaButton").style.background = '#DDDDDD'
  //           },

  //           // 验证失败事务处理
  //           failure: function (e) {
  //               console.log(e,'pppp');
  //               kg.html(kg.$("#captchaButton"), "验证失败，请重新验证");
  //               kg.$("#captchaButton").style.background = '#aaa'
  //           },

  //           // 点击刷新按钮时触发
  //           refresh: function (e) {
  //               console.log(e);
  //           }
  //       });
  // },

  methods: {
     handlernav(path) {
      this.active = path
      // 如果没有登录 判断 
      let datas = localStorage.getItem('datas')
      if(path == "/price"){
        this.getuserinfo()
        // path = '/login'
      //   // 请求接口，判断是否登录
      //   // let res = await this.$request(getUserInfo, {})
      //   // //已登录
      //   // if(res.code == 0){
      //   //   path = '/price'
      //   // }else{
      //   //    // 没有登录
      //   //    localStorage.removeItem('datas')
      //   //    path = '/login'
      //   // }
      }
      this.$router.push({ path: path })
      // this.getuserinfo()
      // if (index == 1) {
      // } else if (index == 2) {
      //   this.$router.push({ path: '/home/ListPrice' })
      // }
    },
   async getuserinfo(){
      let res = await this.$request(getUserInfo, {})
      if(res.code != 0){
        localStorage.removeItem('datas')
        localStorage.removeItem('user')
      }
      return res
    },
    handlerchanges(index) {
      this.actives = index

    },
    handlerShows() {
      this.$router.push({ path: '/login' })
    },

    handlerTopath(index) {
      // this.$router.push({ name: 'AccountSettings',params:{index:index}})
      this.$router.push({ path: '/AccountSettings',query:{index:index}})
    },
    handlerTopathone(){
      this.$router.push({ path: '/price'})
    },
    handlerTopathtwo(){
      this.$router.push({ path: '/xdkAi' })
    },
    handlerGoback() {
      this.$router.push({ path: '/' })
    },
    handlersend() {

      // let parmas = {
      //   phone:this.ruleForm.phone
      // }
      // this.$request(handlersend,parmas).then(res=>{
      //   console.log(res);
      // })
    },
    hadlerLogins(formName) {
      console.log('submit!');
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //退出登录
    handlerLogout(){
      sessionStorage.removeItem('datas')
      sessionStorage.removeItem('user')
      localStorage.removeItem('datas')
      localStorage.removeItem('user')
      localStorage.removeItem('wechatData')
      this.$message.success('退出成功')
      this.$store.commit('SETTOKENS', "")
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style lang="scss" scoped>
.cozeBg {
  background: transparent !important;
}
.header {
  width: 100%;
  height: 70px;
  background: #111318;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;

  .icons {
    width: 100px;
    height: 28px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .center {
    .list {
      display: flex;
      justify-content: center;
      align-items: center;

      .lis {
        margin: 0 20px;
        position: relative;
        height: 35px;
        font-size: 16px;
        cursor: pointer;
      }

      .active {
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          border-radius: 2px;
          background: #3F57FF;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }

  .rights {
    position: relative;

    .login {
      width: 120px;
      height: 40px;
      background: #3F57FF;
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }

    .userimgs {
      width: 80px;
      height: 70px;
      position: relative;
      transition: all 0.3s;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;

      .imgsdv {
        width: 36px;
        height: 36px;
        // background: #3F57FF;
        border-radius: 50%;
        text-align: center;
        line-height: 36px;
        color: #ffffff;
        font-size: 12px;
        .imgs{
          width: 100%;
          height: 100%;
          display: block;
          border-radius: 50%;
        }
      }

      &:hover {
        .logindv {
          display: block;
        }
      }
    }

    .logindv {
      width: 280px;
      height: 414px;
      display: none;
      background: #ffffff;
      position: absolute;
      top: 69px;
      right: 0px;
      border-radius: 20px;
      padding: 15px;
      box-sizing: border-box;
      z-index: 9999;

      .tops {
        width: 100%;
        height: 36px;
        display: flex;
        justify-self: start;
        align-items: center;
        cursor: pointer;

        .iconsone {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          // background: #3F57FF;
          margin-right: 10px;
          text-align: center;
          line-height: 36px;
          font-size: 12px;
          font-weight: bold;
          overflow: hidden;
          .imgs{
            width: 100%;
            height: 100%;
          }
        }

        .texts {
          font-size: 16px;
          color: #222222;
        }

        &:hover {
          background: #f5f5f5;
        }
      }

      .ctdvs {
        width: 100%;
        height: 109px;
        margin-top: 20px;
        background: url("http://cdn.gugusj.com/xdk/bg09.png") no-repeat;
        background-size: 100% 100%;
        padding: 15px 25px;
        box-sizing: border-box;
        text-align: left;

        .title1 {
          font-size: 16px;
          font-weight: bold;
          color: #222222;
          text-align: left;
        }

        .title2 {
          font-size: 12px;
          color: #666666;
          margin-top: 5px;
        }

        .btns {
          width: 85px;
          height: 28px;
          border-radius: 28px;
          background: #3F57FF;
          color: #ffffff;
          text-align: center;
          font-size: 12px;
          line-height: 28px;
          margin-top: 10px;
          cursor: pointer;
        }
      }

      .list {
        width: 100%;
        margin-top: 17px;
        color: #222222;

        .lis {
          width: 100%;
          height: 40px;
          padding: 0 10px;
          box-sizing: border-box;
          border-radius: 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;

          &:hover {
            background: #f5f5f5;
          }
        }
      }

      .line {
        width: 100%;
        height: 2px;
        background: rgba(221, 221, 221, 0.4);
        margin-top: 20px;
      }

      .loginout {
        height: 40px;
        margin-top: 20px;
        color: #222222;
        text-align: left;
        padding: 0 15px;
        cursor: pointer;
      }
    }
  }

  /deep/ .el-dialog__wrapper {
    background: rgba(0, 0, 0, .5);
  }

  /deep/ .el-dialog {
    background: rgba(0, 0, 0, 0);
  }

  /deep/ .el-dialog__header {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  .tops {
    height: 100%;
    height: 50px;
    position: relative;

    .icons {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: solid 2px #ffffff;
      box-sizing: border-box;
      position: absolute;
      right: -50px;
      top: 0;
      text-align: center;
      line-height: 40px;
      cursor: pointer;

      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }

  .dvboxs {
    width: 500px;
    height: 603px;
    border-radius: 20px;
    background: url("http://cdn.gugusj.com/xdk/bg08.png") no-repeat;
    background-size: 100% 100%;
    padding: 37px;
    box-sizing: border-box;
    position: relative;
    text-align: center;

    .top1 {
      width: 88px;
      height: 24px;
      background: url("http://cdn.gugusj.com/xdk/icon01.png") no-repeat;
      background-size: 100% 100%;
    }

    .titles {
      font-size: 32px;
      font-weight: bold;
      color: #222222;
      margin-top: 44px;
    }

    .list {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 32px;

      .lis {
        margin: 0 15px;
        font-size: 18px;
        position: relative;
        cursor: pointer;
      }

      .active {
        color: #3F57FF;

        &::after {
          content: "";
          width: 30px;
          height: 4px;
          background: #3F57FF;
          border-radius: 2px;
          position: absolute;
          left: 50%;
          bottom: -10px;
          transform: translateX(-50%);
        }
      }
    }

    .erlist {
      .erweima {
        width: 200px;
        height: 200px;
        padding: 10px;
        margin: 40px auto 0;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 10px;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .texts {
        margin-top: 20px;
        font-size: 16px;
        color: #666666;
      }
    }

    .phones {
      width: 365px;
      margin: 42px auto 0;

      .lis {
        margin-bottom: 20px;

        .btns {
          width: 100%;
          height: 56px;
          border-radius: 40px;
          cursor: pointer;
          background: linear-gradient(90deg, #B73AFF, #0CC1FE);
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          font-size: 20px;
        }
      }

      /deep/ .el-input__inner {
        height: 56px;
        line-height: 56px;
        border-radius: 56px;
        padding: 0 40px;
      }

      /deep/ .el-input__suffix {
        right: 10px;
        line-height: 56px;
        padding-right: 10px;
      }

      .sends {
        color: #3F57FF;
        cursor: pointer;
      }
    }

    .foot {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 40px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/HeaderComponent.vue